import React, { useEffect, useContext, useState } from "react";
import DropDown from "../../components/_default/DropDown";
import { updateClients } from "../../services/firebase/firestore/updateData";
import { getAllCoaches } from "../../services/firebase/firestore/getData";

import "./Subs.scss";

function Subclients({ client }) {
    const [status, setStatus] = useState(client.status ? client.status : 'Trial');
    const [coaches, setCoaches] = useState([]);

    const DropDownOptions = ['Closed','Trial'];

    useEffect(() => {
        getAllCoaches(callback => {
          console.log(callback);
            setCoaches(callback);
        })
        // updateClients({status: status}, client.id, callback => {
        //     console.log(callback);
        // })
    }, [status]);

    useEffect(() => {
      updateClients({status: status}, client.id, callback => {
          console.log(callback);
      })
  }, [status])

    let getCoachName = (id) => {
        let coachId = coaches.filter((coach) => { return coach.id == id });
        console.log(coachId[0]);
        if(coachId[0] && coachId[0].first_name && coachId[0].last_name){
            return coachId[0].first_name+' '+coachId[0].last_name;
        } else {
            return <i>Coach not found</i>;
        }
        //return coachId[0].first_name+' '+coachId[0].last_name;
    }


    return (
        <div className="c-exercise-list-item no-hover" style={{ padding: 10 }}>
          <div className="c-exercise-list-item-data">
            <div className="c-exercise-user-image" style={{ backgroundImage: `url('${client.image}')` }}>
                {client.image === "" && <p>{client.first_name[0] + client.last_name.match(/\b(\w)/g).join("")}</p>}
              </div>
            <div className="c-exercise-text">
              <h3>{client.first_name} { client.last_name }</h3>
              <p style={{fontWeight: 300}}>{ client.email }</p>
            </div>
            {
              client?.registrationDate&&
            
            <div className="c-exercise-text">
              
              <p style={{fontWeight: 300,paddingLeft:"100px"}}>{client?.registrationDate?.toDate().getDate()}/{client?.registrationDate?.toDate().getMonth() + 1}/{client?.registrationDate?.toDate().getFullYear()}</p>
            </div>
            }
          </div>
          { !client.coach ? (
              <div style={{ paddingRight: 20 }}>
              { !client.admin ? (
                <span><i>No coach </i> <div className="c-exercise-icons">
                  <DropDown zindex={ 'auto' } options={DropDownOptions ? DropDownOptions : []} value={status} onChange={(e) => {setStatus(e)}} />
                 </div></span>
              ) : <span><i>Admin </i></span> }
              </div> ) : (<div>{ getCoachName(client.coach) }</div>)
            }
        </div>
    )
}

export default Subclients;